import _mapKeys from 'lodash/mapKeys';
import {CALL_API} from '../middleware/apiMiddleware';

export const UPDATE_LANG = 'actions/UPDATE_LANG';
export const TOGGLE_SNACKBAR = 'actions/TOGGLE_SNACKBAR';
export const REQ_START = 'actions/REQ_START';
export const REQ_END = 'actions/REQ_END';
export const FETCH_USERS = 'actions/FETCH_USERS';
export const RECEIVE_USERS = 'actions/RECEIVE_USERS';

export const updateLang = (params = {}) => (dispatch) => {
  const {lang} = params;
  return dispatch({
    type: UPDATE_LANG,
    payload: {lang},
  })
}

export const toggleSnackbar = (params = {}) => (dispatch) => {
  const action = {
    type: TOGGLE_SNACKBAR,
    message: params.message,
    open: params.open,
  }
  return dispatch(action);
}


export const reqStart = (params = {}) => (dispatch, getState) => {
  const {action} = params;
  const reduxAction = {
    type: REQ_START,
    status: 'pending',
    statusCode: null,
    action,
  }
  dispatch(reduxAction);
}


export const reqEnd = (params = {}) => (dispatch, getState) => {
  const {
    action,
    response = null,
    error = null,
  } = params;

  let reduxAction;

  if (response) {
    reduxAction = {
      type: REQ_END,
      status: 'success',
      statusCode: response.status,
      action,
    }
  }
  else if (error) {
    if (error.response) {
      reduxAction = {
        type: REQ_END,
        status: 'failed',
        statusCode: error.response.status,
        action,
      }
    }
    else {
      reduxAction = {
        type: REQ_END,
        status: 'failed',
        statusCode: 500,
        action,
      }
    }
  }
  dispatch(reduxAction);
}

export const fetchUsers = (params = {}) => (dispatch) => {

  const config = {
    method: 'get',
    url: '/users',
  }

  const apiCall = {
    [CALL_API]: {
      type: FETCH_USERS,
      config,
    }
  }

  //console.log('config', config)
  return dispatch(apiCall)
  .then(response => {
    //console.log('response', response)
    const users = response.data.data;
    const action = {
      type: RECEIVE_USERS,
      payload: {users},
    }
    dispatch(action);
    Promise.resolve(response);
  })
}

const initialState = {
  ui: {
    lang: 'en',
  },
  users: {

  },
}

export const reducer = (state = initialState, action) => {
  switch(action.type) {

    case RECEIVE_USERS: {
      const {users} = action.payload;
      const nextState = {
        ...state,
        users: _mapKeys(users, 'id'),
      }
      return nextState;
    }

    case UPDATE_LANG: {
      const {lang} = action.payload;
      const nextState = {
        ...state,
        ui: {
          ...state.ui,
          lang,
        }
      }
      return nextState;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js